import { gql } from '@apollo/client';
import { Client } from '../../fragments/client/client.fragments';

export const ADD_PUBLIC_ORDER = gql`
  mutation AddPublicOrder($shopId: String!, $order: Order!, $classeId: ID!) {
    createOrder(order: $order, shopId: $shopId, classeId: $classeId) {
      commande {
        id
        createdAt
        fraislivraison
        methodepaiement
        numerocommande
        payment
        totalttc
        prixTotal
        customerContributedToTheOng
        status
        user {
          classe {
            debut
            fin
            operationid
            filliere {
              name
            }
            lycee {
              name
              academie {
                name
              }
            }
            niveau {
              name
            }
          }
          firstname
          lastname
          email
        }
        commandelines {
          id
          quantite
          produit {
            id
            name
            ttcPrice
            ref
            venterebond
            media {
              url
            }
          }
        }
        client {
          ...ClientResult
        }
      }
      sherlock {
        interfaceVersion
        data
        redirectionUrl
        seal
        automaticResponseUrl
      }
    }
  }
  ${Client.fragments.clientResult}
`;
